import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import PubSub from "services/PubSub/";
import TagManagerService from 'services/TagManager/';
import CartAction from 'actions/Cart';
import repeatOrderIcn from 'images/menu/repeat-order.svg'
import OrdersService from 'services/Orders/';
import { userMenuTxt } from 'config/translate/variables';

const RepeatLastOrder = () => {
    const [lastOrder, setLastOrder] = useState(false);
    const [isMobile, setMobile] = useState(false);

    useEffect(() => {
        getLastOrder();
    },[]);

    useEffect(() => {

        if (window) {
            checkViewport();
            window.addEventListener("resize", checkViewport);
        }

        return function cleanup() {

            if (window) {
                window.removeEventListener("resize", checkViewport);
            }
        }
    }, []);

    const clickTagManager = (action, tag) => {
        TagManagerService.clickHeader(action, tag);
    };

    const getLastOrder = () => {
        OrdersService.getLastOrder().then(data => {
            setLastOrder(data);
        });
    };

    const applyLastOrder = (order) => {

        const { items } = order;
        const listProducts = [];
        const currentProducts = [];

        items.map(item => {
            const itemsFormatted = { "id": item.id, "quantity": item.quantity };
            listProducts.push(itemsFormatted);
        });

        CartAction.getCart().then(orderForm => {
            const currentItems = orderForm.items;
            
            currentItems.map(item => {
                const currentItemsFormatted = { "id": item.id, "quantity": item.quantity };
                currentProducts.push(currentItemsFormatted);
            });

            if(sortItemsId(currentProducts).length === 0) {

                _addItems(listProducts);

            } else {

                if(JSON.stringify(sortItemsId(currentProducts)) === JSON.stringify(sortItemsId(listProducts))){
                    return false;
                }else {

                    PubSub.dispatch('modal_confirmation_open', {
                        message: "<strong class='last-order-title'>Repetir última compra</strong><span class='text'>Tienes productos agregados al carro anteriormente,</span><span class='text'>¿Quieres mezclarlos con tu última compra o hacer un nuevo pedido?</span>",
                        cancelBtnText: 'Nuevo pedido',
                        confirmBtnText: 'Mezclar',
                        confirmCallback: () => {
                            setTimeout(() => {
                                _addItems(listProducts);
                            },0)
                        },
                        cancelCallback: () => {
                            setTimeout(() => {
                                emptyCart(listProducts);
                            },0)
                        }
                    });
                
                }
            }       

            clickTagManager(userMenuTxt.repeatOrder, '');

        });

    }

    const _addItems = (listProducts) => {
        const addItems = CartAction.addItems(listProducts).then(data => {
            alertDispatch();
            return data;
        });
        
        PubSub.dispatch('cart_productAdd', { promise: addItems });
    }

    const alertDispatch = () => {
        PubSub.dispatch('open_snackbar',{
            TitleMobile: '¡Productos en tu carro!',
            TitleDesktop: `¡Productos en tu carro!`,
            Subtitle:'Acabas de agregar los productos de tu última compra.',
            timer: 5000,
            type: 'repeatLastOrder'
        });
    }

    const sortItemsId = (items) => {
        let itemsOrder = items.slice(0);
        
        itemsOrder.sort((a,b) => {
            return a.id - b.id;
        });

        return itemsOrder;
    }

    const emptyCart = (listProducts) => {

        const emptyCartPromise = CartAction.clearCart().then((orderForm) => {
            _addItems(listProducts);
            return orderForm;
        });

        PubSub.dispatch('cart_productRemove', {promise: emptyCartPromise});
    };

    const checkViewport = () => {
        if (!document) return false;
        const $body = document.querySelector('body');
        const viewportWidth = $body.clientWidth;
        const currentIsMobile = viewportWidth <= 1024;

        setMobile(currentIsMobile);

    };


    if(!(lastOrder && lastOrder.data && lastOrder.data.items)) return '';
    
    return(
        <> 
            <button className="last-order repeat-order" onClick={() => applyLastOrder(lastOrder.data)}>
                {isMobile && <div dangerouslySetInnerHTML={{ __html: repeatOrderIcn }} className="menu-icon"></div>}
                {userMenuTxt.repeatOrder}
            </button>
        </>
    )
};

RepeatLastOrder.propTypes = {
    name: PropTypes.string
}
export default RepeatLastOrder;
